<template>
  <div class="app-container">
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="8" class="flex">
        <span>
          用户编号：
        </span>
        <el-input v-model="search.userNum" placeholder="请输入用户姓名"></el-input>
      </el-col>
      <el-col :span="8" class="flex">
        <span>
          注册时间:
        </span>
        <el-date-picker v-model="search.activityTimeDataArr" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :disabled="isEdit" style="width:100%">
        </el-date-picker>
      </el-col>
      <el-col :span="8" class="flex">
        <span>
          账户类型:
        </span>
        <el-select v-model="search.userType" placeholder="请选择" clearable style="width:100%">
          <el-option v-for="item in userTypeList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="8" class="flex">
        <span>
          注册手机号:
        </span>
        <el-input v-model="search.phone" placeholder="请输入注册手机号"></el-input>
      </el-col>
      <el-col :span="8" class="flex">
        <span>
          账户状态:
        </span>
        <el-select v-model="search.userState" placeholder="请选择" clearable style="width:100%">
          <el-option v-for="item in userStateList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="flex">
        <el-button type="primary" size="medium" @click="goAdd()">创建用户</el-button>
        <el-button type="primary" size="medium" @click="getList()">查询</el-button>
        <el-button size="medium" @click="resetForm()">重置</el-button>
        <el-button size="medium" @click="exportUser()">导出</el-button>
      </el-col>
    </el-row>

    <el-table ref="checktableData" :data="list" v-loading="listLoading" @selection-change="handleSelectionChange" :reserve-selection="true" :cell-style="rowStyle" height="60vh">
      <el-table-column type="selection" min-width="50" align="center">
      </el-table-column>
      <el-table-column label="用户编号" min-width="120" align="center">
        <template slot-scope="scope">{{scope.row.userNum}}</template>
      </el-table-column>
      <el-table-column label="用户类型" min-width="100" align="center">
        <template slot-scope="scope">{{scope.row.userType | userType}}</template>
      </el-table-column>
      <el-table-column label="账号状态" min-width="100" align="center">
        <template slot-scope="scope">{{scope.row.userState | userStateType}}</template>
      </el-table-column>
      <el-table-column label="注册时间" min-width="220" align="center">
        <template slot-scope="scope">{{scope.row.createdDate | formatDateTimeDefault}}</template>
      </el-table-column>
      <el-table-column label="注册手机号" min-width="200" align="center">
        <template slot-scope="scope">{{scope.row.phone}}</template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="150" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="goEdit(scope.row.id)">编辑</el-button>
          <el-button type="text" @click="delectUser(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total, sizes,prev, pager, next,jumper" :current-page.sync="search.pageNum" :page-size="search.pageSize" :page-sizes="[10,20]" :total="total">
      </el-pagination>

    </div>

  </div>

</template>

<script>

export default {
  name: 'home',
  data() {
    return {
      list: [],
      search: {
        userNum: "",  //用户编号
        phone: "",  //注册手机号
        userState: "",//用户状态：0冻结，1可用
        createtimeTo: "", //注册时间（结束）
        createtimeFrom: "", //注册时间（开始）
        pageSize: 10,
        userType: "",  //用户类型1,用户 2,回收员 3,网点
        pageNum: 1,
        activityTimeDataArr: [],
      },
      isEdit: false,
      listLoading: false,
      userTypeList: [
        {
          label: "用户",
          value: "1",
        },
        {
          label: "回收员",
          value: "2",
        },
        {
          label: "网点",
          value: "3",
        },
      ],
      userStateList: [
        {
          label: "冻结",
          value: "0",
        },
        {
          label: "可用",
          value: "1",
        },
      ],
      // 选中过的页码
      selectedPageNums: [],
      // 选中也所有的数据
      selectedAllData: [],
      // 是否全选中
      allChecked: false,
      allSelectedIds: [],
      unSelectedIds: [],// 所有未选中的id
      oldarr: [],
      arr: [],
      total: 20,
    }
  },
  filters: {
    userStateType(value) {
      if (value) {
        return '可用'
      } else {
        return '冻结'
      }
    },
    userType(value) {
      if (value === 1) {
        return '用户'
      } else if (value === 2) {
        return '回收员'
      } else {
        return '网点'
      }
    }
  },
  created() {
    this.getList()
    // console.log(this.$route, "route")
  },
  methods: {
    paramsData() {
      let { userNum, phone, userState, activityTimeDataArr, pageSize, userType, pageNum, } = this.search || ''
      let params = {
        userNum: userNum,  //用户编号
        phone: phone,  //注册手机号
        userState: userState,//用户状态：0冻结，1可用
        createtimeTo: activityTimeDataArr[1] || '', //注册时间（结束）
        createtimeFrom: activityTimeDataArr[0] || '', //注册时间（开始）
        pageSize: pageSize,
        userType: userType,  //用户类型1,用户 2,回收员 3,网点
        pageNum: pageNum,
      }
      return params
    },
    getList() {
      this.HttpService.post('/autoapp-recovery-server-auth/api/recoveryUser/getUserList', this.paramsData()).then(res => {
        if (res.statusCode === 200)
          this.total = res.total
        this.arr = res.data
        this.list = this.arr.slice(0, this.search.pageSize)
      })
    },
    exportUser() {
      this.global.exportExcel('/autoapp-recovery-server-auth/api/recoveryUser/exportUser', this.paramsData(), '用户明细表').catch((res) => {
        let blob = new Blob([res.response.data], {
          type: 'application/json',
        });
        var blobReader = new Response(blob).json();
        blobReader.then((res) => {
          this.$message.error(res.message);
        });
      });
    },
    rowStyle() {
      return "text-align:center";
    },
    handleSelectionChange(rows) {
      // console.log(rows);
      // this.allSelectedIds 所有页选中的数据
      // this.currentTableData  当前页所有的数据
      // selectedIds  选中的项
      // unSelectedIds  未选中的项
      const selectedIds = rows.map((item) => item.id);
      const unSelectedIds = this.list
        .map((item) => item.id)
        .filter((item) => !selectedIds.includes(item));
      // // 获的所有选中的项
      this.allSelectedIds = this.allSelectedIds.filter(
        (item) => !unSelectedIds.includes(item)
      );
      // // //获得未选中的项
      this.unSelectedIds = unSelectedIds
      // // 数组去重
      this.allSelectedIds = [
        ...new Set([...this.allSelectedIds, ...selectedIds]),
      ];
      console.log(this.allSelectedIds, "this.allSelectedIds")
    },
    handleSizeChange(val) {
      this.search.pageNum = 1;
      this.search.pageSize = val;
      this.getList()
    },
    handleCurrentChange() {
      // this.oldarr = this.oldarr.concat(this.unSelectedIds)
      // this.unSelectedIds = [...new Set(this.oldarr)]
      this.getList()
    },
    resetForm(formName) {
      this.search = this.$options.data().search
    },
    delectUser(id) {
      this.$dialog({
        title: '温馨提示',
        content: '是否要删除此用户，删除后不可以恢复！',
        cancel_buttton: '否',
        ok_buttton: '是',
        footBtn: false,
        width: '400px',
        footBtn: 'card',
        dialogType: 'delete',
        onOk: () => {
          if (id)
            this.HttpService.post(`/autoapp-recovery-server-auth/api/recoveryUser/delUser/${id}`).then(res => {
              if (res.statusCode === 200)
                this.$message.success('删除成功')
              this.getList()
            })
        },
        onCancel: () => {
          console.log('cancel');
        }
      })
    },
    goAdd() {
      this.$router.push({
        path: "/user/userAdd",
        query: {
        }
      });
    },
    goEdit(id) {
      this.$router.push({
        path: "/user/userEdit",
        query: {
          id: id
        }
      });
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
  // margin: 0 20px;
  padding: 0 20px;
  span {
    min-width: 100px;
  }
}
.row-bg {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue